(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/pepp-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/pepp-text.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
const PeppText = _ref => {
  var _result$location;
  let result = _ref.result;
  const winningLocationName = result === null || result === void 0 || (_result$location = result.location) === null || _result$location === void 0 ? void 0 : _result$location.county;
  const distribution = (result === null || result === void 0 ? void 0 : result.distribution) || [];
  const totalWinAmount = distribution.reduce((acc, dist) => acc + dist.winners * parseInt(dist.amountSek, 10), 0);
  return React.createElement("div", {
    className: "lp-pepp-text lp-header f-content has-grid"
  }, React.createElement("div", {
    className: "pepp-text-body"
  }, React.createElement("h3", null, "Grattis ".concat(winningLocationName, " och alla med lyckoplatser inom vinstcirklarna till vinster f\xF6r"), React.createElement("span", null, " ".concat(formatCurrency(totalWinAmount), " kr!")))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  PeppText
});

 })(window);